import ICommand from "./ICommand";
import {useAppSelector} from "../hooks";
import {formatDate} from "../format/DateFormat";
import {selectLogEntries} from "../redux/logs";
import {selectMembers} from "../redux/members";
import useMessageLogic from "../logic/useMessageLogic";

export const useLsCommand = (): ICommand => {
  const logs = useAppSelector(selectLogEntries)
  const members = useAppSelector(selectMembers)
  const messages = useMessageLogic()

  return {
    secure: true,

    help(): string {
      return '- ls\t\t\t\t\t:: shows the most recent journal entries';
    },

    async process(msg: string): Promise<void> {
      let logList = '';
      logs.forEach((log, index) => {
        const date = new Date(log.createdAt)
        const lines = log.entry.split('\n')
        const firstLine = (lines[0] ?? '').trim()
        const title = firstLine.startsWith('# ') ? firstLine.substring(2) : 'Untitled'
        const dateString = formatDate(date)
        const authors = members.filter((m) => log.authorIds.includes(m.id))
        const authorNames = authors.map((a) => a.name).join(', ')
        logList += `\n${index}.\t${title}\t${dateString}\t${authorNames}`
      })
      messages.addNoticeMessage(logList)
    },

    matches(msg: string): boolean {
      return ['ls'].includes(msg.toLowerCase().trim())
    }
  };
}